import ReactPaginate from "react-paginate";
import {useTable} from "react-table";
import {IAgTableProps} from "./AgTable.props";
import {CustomsPaging} from "./AgTable.styled";
import { LoadingIcon } from "../../assets/svg/loadingIcon";

const AgTable: React.FC<IAgTableProps> = (
    {
        columns,
        data,
        maxLength,
        page,
        entriesPerPage = 8,
        onHandleNextPage,
        pageCount,
        isClickOnRow = false,
        onClickOnRow,
        textNoDataFound = "No results found.",
        isLoading= false,
        ...props
    }: IAgTableProps
) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data })

    return <div className="rounded-[10px] bg-white">
        <table {...getTableProps()} className="w-full table-auto">
            <thead>
                {
                    headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()} >
                            {headerGroup.headers.map(column => (
                                <th
                                    {...column.getHeaderProps()}
                                    className={`py-[20px] pr-[10px] first:pl-[20px] last:pr-[20px] text-[0.9375rem] font-medium text-start text-[#58585B] ${column.Header === 'Action' ? 'sticky right-0 z-10 bg-white pl-[5px]' : ''}`}
                                    style={
                                        {
                                            width: `${column.width ?? ''}`
                                        }
                                    }
                                >
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))
                }
            </thead>
           {
            !isLoading ?
            <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <tr 
                        {...row.getRowProps()}
                        className={`border-t-[1px] border-solid border-[#EAEAEA] ${
                        isClickOnRow ? "cursor-pointer hover:opacity-80" : ""
                        }`}
                        onClick={(e) => isClickOnRow && onClickOnRow && onClickOnRow(row.original, e)}        
                        >
                            {row.cells.map((cell: any, j) => {
                                return (
                                    <td
                                        rowSpan={cell.rowSpan}
                                        {...cell.getCellProps()}
                                        className={`py-[6px] pr-[10px] first:pl-[20px] last:pr-[20px] text-[14px] font-normal text-[#637381] text-start ${cell.column.Header === 'Action' ? 'sticky right-0 z-10 bg-white pl-[5px]' : ''}`}
                                    >
                                        {cell.render("Cell")}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
            :null
           }
        </table>

        {
            isLoading ?
            <div className="flex flex-row px-[20px] py-[5px] justify-center border-t-[1px]">
                <LoadingIcon width={60} height={60} />
            </div>:  data && data.length ?
                <CustomsPaging className="flex flex-row px-[20px] py-[5px] justify-end border-t-[1px] border-solid border-[#EAEAEA]">
                    <ReactPaginate
                        onPageChange={(e) => { onHandleNextPage && onHandleNextPage(e.selected + 1) }}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={2}
                        pageCount={pageCount ?? 1}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item page-item-disabled"
                        previousLinkClassName="page-link"
                        nextClassName="page-item page-item-disabled"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item page-item-break"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={(page ?? 1) - 1}
                    />
                </CustomsPaging> : 
                <div className="flex flex-row px-[20px] py-[5px] justify-center border-t-[1px] border-solid border-[#EAEAEA]">
                    <p className="text-[14px] font-normal text-[#637381]">{textNoDataFound ?? "No Records Found"}</p>
                </div>
        }
    </div>
};

export default AgTable;
